module.exports = __webpack_public_path__ + "media/images/icons/049__mail-0e63f5f2b2a552b5d5e593af08a50584.svg";